import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';

import { userCanEditPeople } from '../../helpers/Files';

const FilePersonName = ({
  dispatch,
  file,
  face,
  readOnly,
}) => {
  const intl = useIntl();

  const [editedName, setEditedName] = useState(face.person?.name);

  const isEditPeopleAllowed = userCanEditPeople(file) && !readOnly;

  useEffect(() => {
    setEditedName(face.person?.name);
  }, [face]);

  const openChangePersonModal = (e) => {
    e.preventDefault();

    if (!isEditPeopleAllowed) {
      return;
    }

    dispatch(showModal('ChangePersonModal', {
      className: 'modal-change-person',
      face,
    }));
  };

  return (
    <div className="file-face file-details-item">
      <div className="file-detail-body">
        {(
          !readOnly &&
          face.person?.similar &&
          face.person?.similar.length > 0 &&
          face.person?.name
        ) && (
          <div className="similar-people">
            {intl.formatMessage({ defaultMessage: 'There are other people with the same name.' })}
            {' '}
            <a href="#people" onClick={openChangePersonModal}>
              {intl.formatMessage({ defaultMessage: 'Check' })}
            </a>
          </div>
        )}
        <div
          className={classnames(
            'editable-field',
            'editable-field-person',
            {
              'editable-field-disabled': !userCanEditPeople(file),
              'editable-field-read-only': readOnly,
            },
          )}
          role="button"
          tabIndex={0}
          title={intl.formatMessage({ defaultMessage: 'Click to edit' })}
          onKeyUp={openChangePersonModal}
          onClick={openChangePersonModal}
        >
          <div className={classnames('file-face', { unnamed: !editedName })}>
            {isEditPeopleAllowed ? (
              editedName || intl.formatMessage({ defaultMessage: 'Click to name this person' })
            ) : (
              editedName || intl.formatMessage({ defaultMessage: 'Unnamed person' })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

FilePersonName.propTypes = {
  dispatch: PropTypes.func.isRequired,
  face: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

FilePersonName.defaultProps = {
  readOnly: false,
};

export default connect()(FilePersonName);
